
import apiClient from "../../../../services/apiClient";


const patRegxUkr = new RegExp(`^[1,'II','III','IV','V','VI','VII','VIIІ','IX']{0,3}[\\s,-]{0,1}[А-Я,Є,І,Ї,A,B,C,E,H,I,K,M,O,P,T,X,]{2}[\\s,-]{0,1}[\\d]{6}$`,"i");

const UKRAINIAN_LETTERS_REGEX = /^[а-щьюяґєіїА-ЩЬЮЯҐЄІІЇ\'\-\s]+$/;

const validateBirthDate = (date) => {
    if (!date) return null;
    
    const birthDate = new Date(date);
    const today = new Date();
    
    // 1. Дата рождения не может быть больше текущей
    if (birthDate > today) {
      return 'Дата народження не може бути у майбутньому';
    }
    
    // 3. Проверка что ребенку уже исполнилось 8 лет
    const eightYearsAgo = new Date();
    eightYearsAgo.setFullYear(eightYearsAgo.getFullYear() - 8);
    eightYearsAgo.setMonth(8,30);
    
    if (birthDate < eightYearsAgo) {
      return 'Дитині вже виповнилось 8 років';
    }
    
    return null;
  };


  const validateCertificateDate = (certificateDate, birthDate) => {
    if (!certificateDate || !birthDate) return null;
    
    const certDate = new Date(certificateDate);
    const bDate = new Date(birthDate);
    
    // 2. Дата выдачи свидетельства не может быть меньше даты рождения
    if (certDate < bDate) {
      return 'Дата видачі свідоцтва не може бути раніше дати народження';
    }
    
    const today = new Date();
    
    // Дата выдачи не может быть в будущем
    if (certDate > today) {
      return 'Дата видачі свідоцтва не може бути у майбутньому';
    }
    
    return null;
  };

  // Валидация адреса
export const validateAddress = (address) => {
  if (!address) {
    return 'Адреса обовʼязкова для заповнення';
  }

  const { district, street, building } = address;

  if (!district?.trim()) {
    return 'Район обовʼязковий для заповнення';
  }

  if (!street?.trim()) {
    return 'Вулиця обовʼязкова для заповнення';
  }

  if (!building?.trim()) {
    return 'Номер будинку обовʼязковий для заповнення';
  }

  return null;
};



async function Validate(formData, isEdit){

    const errors = {};

    const {child} = formData;

    const {birthCertificate} = child;

    const {country, seriesNumber, issueDate, files} = birthCertificate;

    const isValid = country == 'ua' && patRegxUkr.test(seriesNumber) ? true : country !== 'ua' ? true : false;


    if (child.lastName && !UKRAINIAN_LETTERS_REGEX.test(formData.child.lastName)) {
        errors.childLastName = 'Прізвище має містити тільки українські літери, апостроф або дефіс';
    }

    if (child.firstName && !UKRAINIAN_LETTERS_REGEX.test(formData.child.firstName)) {
        errors.childFirstName = "Ім'я має містити тільки українські літери, апостроф або дефіс";
    }

    if (child.middleName && !UKRAINIAN_LETTERS_REGEX.test(formData.child.middleName)) {
        errors.childMiddleName = 'По батькові має містити тільки українські літери, апостроф або дефіс';
    }

    if (!child.lastName) errors.childLastName = 'Прізвище обов\'язкове';
    if (!child.firstName) errors.childFirstName = 'Ім\'я обов\'язкове';
    if (!child.birthDate) {
      errors.childBirthDate = 'Дата народження обов\'язкова';
    }
    if (!child.birthCertificate.seriesNumber) {
      errors.childCertificate = 'Серія та номер свідоцтва обов\'язкові';
    }

    if (files.length == 0) {
      errors["childCertificateScan"] = 'Скан-копія свідоцтва обов\'язкова';
    }
    if (!child.address) errors.childAddress = 'Адреса обов\'язкова';

    // Проверка адреса регистрации
    const addressError = validateAddress(formData.child.address, 'childaddress');

    console.log('childaddress error', addressError);
    if (addressError) {
        errors.childaddress = addressError;
    }

    // Проверка фактического адреса (если отличается от регистрации)
    if (formData.child.sameFactAddress === "no") {
        const addressFactError = validateAddress(formData.child.addressFact, 'childaddressFact');
        if (addressFactError) {
        errors.childaddressFact = addressFactError;
        }
    }

    const isNonValidBirthDate = validateBirthDate(child.birthDate);
    const isNonValidCertificate = validateCertificateDate(issueDate, child.birthDate);

    if(isNonValidBirthDate) errors.childBirthDate = isNonValidBirthDate;
    if(isNonValidCertificate) errors.childCertificateDate = isNonValidCertificate;


    if(!isValid) {errors['childCertificate'] = 'Не відповідає формату свідотства про народження'; return errors};

    if(!isEdit){

        if(!seriesNumber) return errors;

         const isSame = await apiClient.post('requests/checkSameCertNumber',{ 'bcnumber': seriesNumber});


         if(isSame.data && isSame.data == 'true') errors['childCertificate'] = "В системі вже є зареєстрована заявка на вступ з цим номером свідоцтва";

         const isBroterSame = await apiClient.post('request/check_brother_date', { childrenName: child.firstName, childrenBirthDate: child.birthDate});
         
         if((isBroterSame.data?.status == "success") && (isBroterSame.data?.data?.count > 0)) {
          errors.childFirstName = "Схоже, ви вже маєте заявку на цю дитину близнюка";
          errors.childBirthDate = 'Схоже, ви вже маєте заявку на цю дитину близнюка';
         }

    }
    

    return errors;


}

export default Validate;